import ArrowDownwardRoundedIcon from '@mui/icons-material/ArrowDownwardRounded';
import ArrowUpwardRoundedIcon from '@mui/icons-material/ArrowUpwardRounded';
import React from 'react';

import type { Change } from './seoData';

/**
 * A change with its direction: an arrow and a colour for up or down, plain text for no change or a
 * new entry. The arrow carries the direction for anyone who cannot tell the two colours apart.
 */
const ChangeValue: React.FC<{ change: Change; label: string }> = ({
  change,
  label,
}) => (
  <span
    className={`seo-change seo-change--${change.dir}`}
    title={`${label}: ${change.text}`}
  >
    {change.dir === 'up' && <ArrowUpwardRoundedIcon aria-hidden="true" />}
    {change.dir === 'down' && <ArrowDownwardRoundedIcon aria-hidden="true" />}
    {change.text}
  </span>
);

export default ChangeValue;
